module.exports = __webpack_public_path__ + "static/img/MX.21c42bd1.png";